import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BeanDestType } from 'src/bean/BeanDestType';
import { BeanDestinatarios } from 'src/bean/BeanDestinatarios';
import { BeanOperacao } from '../../../bean/BeanOperacao';
import { CadastroOperacaoervice } from './cadastro-operacao.service';


@Component({
  selector: 'app-cadastro-operacao',
  templateUrl: './cadastro-operacao.component.html',
  styleUrls: ['./cadastro-operacao.component.css']
})
export class CadastroOperacaoComponent implements OnInit {

  @ViewChild('sortOperacao') sortOperacao = new MatSort();
  @ViewChild('sortDest') sortDest = new MatSort();
  @ViewChild('sortDestCont') sortDestCont = new MatSort();

  public lstOperacoes: BeanOperacao[] = []
  idUsuarioEdicao : number = 1 ;
  dataSource = new MatTableDataSource<BeanOperacao>();
  dataSourceDest = new MatTableDataSource<BeanDestinatarios>();
  dataSourceDestCont = new MatTableDataSource<BeanDestinatarios>();
  selectedIndex: number = 0;
  operacaoBean : BeanOperacao;
  public sessionExpired = false;
  public lstCmbOperacao: BeanOperacao[];
  public lstdestinatarios: BeanDestinatarios[];
  lstDestType: BeanDestType[];

  constructor(
                private operacaoService: CadastroOperacaoervice,
                private toastr: ToastrService,
                private datePipe: DatePipe,
                private router: Router ) { }

  ngOnInit(): void {
    this.listarOperacoes();
    this.listarDestType();
  }

  ngAfterContentChecked(){

    this.resetSessionExpired();
  }

  public sair() {

    this.sessionExpired = false;
    localStorage.clear();
    this.router.navigate([''])

  }

  public setSessionExpired(errorResponse:any) : boolean {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

			this.sair();
			this.toastr.warning("Sua sessão expirou, faça o login novamente!");
		}
  }

  public formulario: FormGroup = new FormGroup({
    'idOperacao': new FormControl(""),
    'operNmOperacao': new FormControl("", Validators.required),
    'operDsCentroCusto': new FormControl("", Validators.required),
    'isInativo': new FormControl("")

  })

  public destinatario: FormGroup = new FormGroup({
    'idDeopCdDestoper': new FormControl(""),
    'operIdCdOperacao': new FormControl("", Validators.required),
    'idTideCdTipoDestinatario': new FormControl("", Validators.required),
    'deopDsDestinatario': new FormControl('', [Validators.required, Validators.email]),
    'deopDhInativo': new FormControl("")
  })

  public add():void{

    if( this.formulario.get("operNmOperacao").value == "" || this.formulario.get("operDsCentroCusto").value == "" ){
        this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
        return
    }


    var dhInativo = null
    if(this.formulario.value.isInativo == true){
      dhInativo = '1900-01-01T00:00:00' //preencher para o backend pega o getDate()
    }

    this.operacaoBean = new BeanOperacao (
      this.formulario.get("idOperacao").value,
      this.formulario.get("operNmOperacao").value,
      this.formulario.get("operDsCentroCusto").value,
      '',
      dhInativo,
      []
    );


    if(this.formulario.value.idOperacao != '' && this.formulario.value.idOperacao > 0){

      //EDITAR OPERAÇÃO
      this.operacaoService.updateOperacao(this.operacaoBean).then((retorno:any)=>{

        this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
        this.listarOperacoes();
        this.clearFormulario();

      },
        errorResponse => {
        this.setSessionExpired(errorResponse) ? true : this.toastr.error(' Erro ao Atualizar Operação', 'ERRO AO ATUALIZAR');


      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }else{

        //CRIAR NOVA OPERAÇÃO
        this.operacaoService.addOperacao(this.operacaoBean).then((retorno:any)=>{

          this.toastr.success(' Inserido com sucesso', 'SUCESSO AO GRAVAR')
          this.listarOperacoes();
          this.clearFormulario();

        },errorResponse => {

          this.setSessionExpired(errorResponse) ? true : this.toastr.error(' Erro ao gravar Operação', 'ERRO AO GRAVAR');

        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });

    }





  }

  clearFormulario(){

    //limpar
    this.formulario.controls['idOperacao'].setValue("");
    this.formulario.controls['operNmOperacao'].setValue("");
    this.formulario.controls['operDsCentroCusto'].setValue("");
    this.formulario.controls['isInativo'].setValue("");

  }



  public listarOperacoes(){

    this.lstCmbOperacao = [];

    this.operacaoService.listarCadastroOperacoes("").then((listOperacao:BeanOperacao[])=>{

      listOperacao.filter(oper => oper.operDhInativo != null).forEach(operacao => {

        operacao.operDhInativo = this.datePipe.transform(new Date(operacao.operDhInativo), "dd/MM/yyyy");
      });

      this.dataSource.data = listOperacao;

      this.dataSource.sort = this.sortOperacao;

      this.lstCmbOperacao = listOperacao;

    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Usuários');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }

  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  displayedColumns: string[] = ['operNmOperacao', 'operDsCentroCusto', 'operDhInativo'];

  setFormUsuario(form: BeanOperacao){
    this.toastr.success('Operação '+form.operNmOperacao+' em edição','MODO EDIÇÃO')
    this.formulario.controls['idOperacao'].setValue(form.operIdCdOperacao);
    this.formulario.controls['operNmOperacao'].setValue(form.operNmOperacao);
    this.formulario.controls['operDsCentroCusto'].setValue(form.operDsCentroCusto);
    this.formulario.controls['isInativo'].setValue(form.operDhInativo == null ? false : true);
  }

  applyFilterDest(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceDest.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceDest.paginator) {
      this.dataSourceDest.paginator.firstPage();
    }
  }

  displayedColumnsDest: string[] = ['deopDsDestinatario', 'deopDhInativo'];

  setFormDestinatario(form: BeanDestinatarios){
    this.toastr.success('Destinatario '+form.deopDsDestinatario+' em edição','MODO EDIÇÃO')

    this.destinatario.controls['idDeopCdDestoper'].setValue(form.idDeopCdDestoper);
    this.destinatario.controls['operIdCdOperacao'].setValue(form.operIdCdOperacao);
    this.destinatario.controls['idTideCdTipoDestinatario'].setValue(form.idTideCdTipoDestinatario);
    this.destinatario.controls['deopDsDestinatario'].setValue(form.deopDsDestinatario);
    this.destinatario.controls['deopDhInativo'].setValue(form.deopDhInativo == null ? false : true);
  }

  onChangeOperacao(valorSelecionado : any){

    for (let index = 0; index < this.lstCmbOperacao.length; index++) {

      if(this.lstCmbOperacao[index].operIdCdOperacao == valorSelecionado.value){
        this.lstdestinatarios = this.lstCmbOperacao[index].destinatarios;
        break;
      }

    }

    this.dataSourceDest.data = this.lstdestinatarios.filter(beanDest => beanDest.idTideCdTipoDestinatario == 1);
    this.dataSourceDest.sort = this.sortDest;
    this.dataSourceDestCont.data = this.lstdestinatarios.filter(beanDest => beanDest.idTideCdTipoDestinatario == 2);
    this.dataSourceDestCont.sort = this.sortDestCont;
  }

  public salvarDestinatario():void{

  if(this.destinatario.controls['operIdCdOperacao'].value == '' || this.destinatario.controls['deopDsDestinatario'].value == ''){

    this.toastr.info(' Preencha a operação e e-mail ', 'INFO');


  }else{

      if(this.destinatario.controls['deopDhInativo'].value){

        this.destinatario.controls['deopDhInativo'].setValue(new Date())
      }else{
        this.destinatario.controls['deopDhInativo'].setValue(null)
      }

      let dest: BeanDestinatarios = new BeanDestinatarios(this.destinatario.controls['idDeopCdDestoper'].value, this.destinatario.controls['operIdCdOperacao'].value,
      this.destinatario.controls['idTideCdTipoDestinatario'].value, this.destinatario.controls['deopDsDestinatario'].value, null, this.destinatario.controls['deopDhInativo'].value);


      if(this.destinatario.controls['idDeopCdDestoper'].value != ""){

        this.operacaoService.atualizaDestinatario(dest).subscribe({
          next: () => {
            this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
            this.listarOperacoes();
            this.clearDestinatario();
          },
          error: errorResponse => {

            this.setSessionExpired(errorResponse) ? true : this.toastr.error(' Erro ao atualizar Destinatário', 'ERRO AO ATUALIZAR');
          }
        })

      }else{

        this.operacaoService.saveDestinatario(dest).then((retorno:any)=>{

          this.toastr.success(' Criado com sucesso', 'SUCESSO AO CRIAR')
          this.listarOperacoes();
          this.clearDestinatario();

        },
          errorResponse => {
          this.setSessionExpired(errorResponse) ? true : this.toastr.error(' Erro ao criar Destinatário', 'ERRO AO CRIAR');


        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });
      }

    }

  }

  clearDestinatario(){

    this.dataSourceDest.data = [];
    this.dataSourceDestCont.data = [];

    this.destinatario.controls['idDeopCdDestoper'].setValue("");
    this.destinatario.controls['operIdCdOperacao'].setValue("");
    this.destinatario.controls['idTideCdTipoDestinatario'].setValue("");
    this.destinatario.controls['deopDsDestinatario'].setValue("");
    this.destinatario.controls['deopDhInativo'].setValue("");

  }

  listarDestType(){

    this.lstDestType = [];

    this.operacaoService.listarDestType().then((listDestType:BeanDestType[])=>{

      this.lstDestType = listDestType;

    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Combo Tipo Destinatário');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }
}
